import React from "react";
import { View, StyleSheet, Text, Linking, Pressable } from "react-native";

type FooterLinksProps = {
  opacityBackground?: boolean;
  showContactUs?: boolean;
};

const FooterLinks: React.FC<FooterLinksProps> = ({
  opacityBackground = false,
  showContactUs = true,
}) => {
  const openURL = (url: string) => {
    Linking.openURL(url).catch((err) =>
      console.error("Failed to open URL:", err),
    );
  };

  return (
    <View
      style={[
        footerStyles.footerLinksContainer,
        opacityBackground && {
          backgroundColor: "rgba(255, 255, 255, 0.50)",
          paddingHorizontal: 10,
          borderRadius: 5,
        },
      ]}
    >
      {showContactUs && (
        <Pressable
          onPress={() =>
            openURL(
              "https://meetings.hubspot.com/kav-ohiomoba?uuid=000a6c6c-4e10-4fc7-876d-7907cc133fb6",
            )
          }
        >
          <Text style={footerStyles.text} numberOfLines={1}>
            Contact Us
          </Text>
        </Pressable>
      )}
      <Pressable onPress={() => openURL("https://www.clinicos.ai/tos")}>
        <Text style={footerStyles.text} numberOfLines={1}>
          Terms of Service
        </Text>
      </Pressable>
      <Pressable
        onPress={() => openURL("https://www.clinicos.ai/privacy-policy")}
      >
        <Text style={footerStyles.text} numberOfLines={1}>
          Privacy Policy
        </Text>
      </Pressable>
    </View>
  );
};

const footerStyles = StyleSheet.create({
  footerLinksContainer: {
    flexDirection: "row",
    gap: 24,
    marginTop: "auto",
  },
  text: {
    fontFamily: "Urbanist500",
    fontSize: 16,
    lineHeight: 16 * 1.4,
    fontStyle: "normal",
    color: "#282B33",
  },
});

export default FooterLinks;
